<mat-card appearance="outlined" class="example-card">
  <mat-card-header>
    <mat-card-title>Product Types</mat-card-title>
    <mat-card-subtitle>Map each product type to a category, used for stocking and channel setup. Drag to reorder.</mat-card-subtitle>
  </mat-card-header>

  <mat-card-content>
    <div *ngIf="loading">Loading...</div>

    <ng-container *ngIf="!loading">
      <div class="pt-header" *ngIf="rows.length">
        <span class="pt-header-handle"></span>
        <span class="pt-header-field">Product Type</span>
        <span class="pt-header-field">Category</span>
        <span class="pt-header-action"></span>
      </div>

      <div cdkDropList (cdkDropListDropped)="drop($event)" class="pt-list">
        <div class="pt-row" *ngFor="let row of rows; let i = index" cdkDrag>
          <mat-icon class="pt-handle" cdkDragHandle>drag_indicator</mat-icon>

          <input class="pt-input" [(ngModel)]="row.key" name="key-{{i}}" placeholder="e.g. BAGUETTE A">

          <input class="pt-input" [(ngModel)]="row.category" name="category-{{i}}" placeholder="e.g. baguetter"
            [matAutocomplete]="categoryAuto">
          <mat-autocomplete #categoryAuto="matAutocomplete">
            <mat-option *ngFor="let category of categories" [value]="category">{{category}}</mat-option>
          </mat-autocomplete>

          <button mat-icon-button color="warn" (click)="removeRow(i)" matTooltip="Remove">
            <mat-icon>close</mat-icon>
          </button>
        </div>

        <div class="pt-empty" *ngIf="!rows.length">
          No product types yet.
        </div>
      </div>
    </ng-container>

    <div class="row-error" *ngIf="hasDuplicateKeys">
      Product type names must be unique.
    </div>

    <button mat-stroked-button (click)="addRow()" [disabled]="loading">
      <mat-icon>add</mat-icon>
      Add product type
    </button>
  </mat-card-content>

  <mat-card-actions>
    <button mat-raised-button color="primary" (click)="save()" [disabled]="loading || saving || hasDuplicateKeys">
      {{ saving ? 'Saving...' : 'Save' }}
    </button>
  </mat-card-actions>
</mat-card>
